(() => {
  if (customElements.get('vwd-local-pickup')) return;
  const distanceMiles = (lat, lon) => {
    const rad = n => n * Math.PI / 180;
    const dLat = rad(lat - 34.476621);
    const dLon = rad(lon - (-117.2874969));
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(rad(34.476621)) * Math.cos(rad(lat)) * Math.sin(dLon / 2) ** 2;
    return 3958.7613 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };
  class LocalPickup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('[data-pickup-check]');
      this.message = this.querySelector('[data-pickup-message]');
      this.content = this.querySelector('[data-pickup-content]');
      this.button.addEventListener('click', () => this.checkLocation());
    }
    checkLocation() {
      if (!navigator.geolocation) {
        this.message.textContent = this.dataset.error;
        return;
      }
      this.button.disabled = true;
      this.message.textContent = this.dataset.checking;
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const miles = distanceMiles(coords.latitude, coords.longitude);
          const accuracyMiles = (coords.accuracy || 0) / 1609.344;
          const eligible = miles + accuracyMiles <= 250;
          this.content.hidden = !eligible;
          this.button.hidden = eligible;
          this.button.disabled = false;
          this.message.textContent = eligible ? '' : this.dataset.outside;
        },
        () => {
          this.content.hidden = true;
          this.message.textContent = this.dataset.error;
          this.button.disabled = false;
        },
        { enableHighAccuracy: false, timeout: 15000, maximumAge: 0 }
      );
    }
  }
  customElements.define('vwd-local-pickup', LocalPickup);
})();